// jQuery_T4NT(document).ready(function($) {
//   // any code js
// });

$(document).ready(function () {
    // Check if the body has the specified class
    if ($('body').hasClass('page_id_89884590124')) {
        // Add a class to the category-content element
        $('.category-content').addClass('pdf-download-link');
    }

    document.querySelector(".pdf-download-link").addEventListener("click", function (event) {
      console.log("pdf-download-link");
        event.preventDefault(); // Prevent the default behavior (opening the link)

        // Get the PDF URL from the link
        var pdfUrl = this.querySelector('a').getAttribute('href');

        // Trigger the download
        downloadPDF(pdfUrl);
    });

});
function downloadPDF(url) {
    // Extract the file name from the URL
    var fileName = url.split('/').pop(); // Get the last part of the URL

    fetch(url)
        .then(response => response.blob())
        .then(blob => {
            // Create a download link
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);

            // Set the download attribute with the extracted file name
            link.download = fileName;

            // Append the link to the body
            document.body.appendChild(link);

            // Trigger a click event on the link
            link.click();

            // Remove the link from the body
            document.body.removeChild(link);
        })
        .catch(error => console.error('Error downloading PDF:', error));
}